import React, {useEffect, useState} from 'react';
import './dashboard.scss';
import {useNavigate} from "react-router-dom";

import PLANNING_SESSION_IMAGE from 'assets/icons/plan_session_icon.png';
import FINANCE_SESSION_IMAGE from 'assets/icons/finance_session_icon.png';
import GROWTH_SESSION_IMAGE from 'assets/icons/growth_session_icon.png';
import {ReactComponent as DATE_ICON} from 'assets/icons/date_icon_2.svg'

import {ReactComponent as PLANNING_IMAGE} from 'assets/dashboard/planning_image.svg';
import {ReactComponent as STARTING_IMAGE} from 'assets/dashboard/starting_image.svg';
import {ReactComponent as GROWING_IMAGE} from 'assets/dashboard/growing_image.svg';

import {InfoCardType, EventsType, NewsDataTypes} from "../../../models";
import {newsData} from "../../../data/newsData";
import {useGetEvents} from "operations/queries";
import {EventCard} from "../../../components";
import {escapeHtml, removeHtml} from 'util/removeHtmlFromString';
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import {formatTime} from 'util/formatTime';
import {useGetArticles} from 'operations/queries/useGetArticles';

export const Dashboard: React.FC = () => {
    const navigate = useNavigate();

    const [events, setEvents] = useState<Array<EventsType>>([])
    const [articles, setArticles] = useState<Array<NewsDataTypes>>([])

    const {data} = useGetEvents();
    const {data: articleData} = useGetArticles();

    const [businessOption] = useState<Array<{ image: any, heading: string, desc: string, link: string }>>([
        {
            image: <PLANNING_IMAGE/>,
            heading: "Planning a Business",
            desc: "What better way to increase your knowledge than.",
            link: "/app/education/plan"
        },
        {
            image: <STARTING_IMAGE/>,
            heading: "Starting a Business",
            desc: "What better way to increase your knowledge than.",
            link: "/app/education/start"
        },
        {
            image: <GROWING_IMAGE/>,
            heading: "Growing a Business",
            desc: "What better way to increase your knowledge than.",
            link: "/app/education/grow"
        },
    ]);

    const [topNews, setTopNews] = useState<InfoCardType[]>([]);

    const [services] = useState<Array<{ image: any, text: string, date: string }>>([
        {image: PLANNING_SESSION_IMAGE, text: "Business Plan Review Session", date: "17-12-2022"},
        {image: FINANCE_SESSION_IMAGE, text: "Accounting & Financial Advice ", date: "17-12-2022"},
        {image: GROWTH_SESSION_IMAGE, text: "Business Growth &  Development ", date: "17-12-2022"},
    ])

    useEffect(() => {
        if (!articleData) return
        let articleList: Array<NewsDataTypes> = [];

        articleData.forEach((article: any) => {
            const articleInfo = article.attributes

            articleList.push({
                id: article.id,
                date: articleInfo.date?.split("T")[0],
                image: process.env.REACT_APP_BASE_URL + articleInfo.image.data.attributes.url,
                author: articleInfo.author,
                heading: articleInfo.heading,
                description: articleInfo.description,
                body: escapeHtml(articleInfo.body),
                link: articleInfo?.link ?? "N/A",
                isPopular: articleInfo?.isPopular ?? 'N/A',
                headerImage: process.env.REACT_APP_BASE_URL + articleInfo.headerImage.data.attributes.url
            })
        })
        setArticles(articleList)
    }, [articleData]);

    useEffect(() => {
        setTopNews(articles.filter((data) => (data.isPopular === true)));
    }, [articles])

    useEffect(() => {
        if (!data) return
        let eventList: Array<EventsType> = [];
        data?.forEach((eventData: any) => {
            const eventDataAttributes = eventData.attributes
            eventList.push({
                id: eventData.id,
                date: eventDataAttributes.date?.split("T")[0],
                time: formatTime(eventDataAttributes.date?.split("T")[1].split(".")[0]),
                venue: eventDataAttributes.venue,
                address: eventDataAttributes.venue.address,
                image: process.env.REACT_APP_BASE_URL + eventDataAttributes.image.data.attributes.url,
                title: escapeHtml(eventDataAttributes.title),
                description: removeHtml(eventDataAttributes.description),
                category: eventDataAttributes?.categories?.data?.map((category: any) => category.attributes.name)
            })
        })
        setEvents(eventList)
    }, [data]);

    return (
        <div className={'dashboard'}>
            <div className={'dashboard_wrapper'}>
                <div className={'dashboard_wrapper_request'}>
                    <div className={'dashboard_wrapper_request_top'}>
                        <h1 className={'heading'}>Lets have a talk</h1>
                    </div>

                    <div className={'dashboard_wrapper_request_services'}>
                        {services.map(({image, text, date}, index) => (
                            <div key={index} className={'dashboard_wrapper_request_services_service'}>
                                <div className={'top_strip'}/>
                                <span id={'service_heading'}>{text}</span>
                                <div key={index} className={'dashboard_wrapper_request_services_service_bottom'}>
                                    <div className={'date'}>
                                        <DATE_ICON/>
                                        <span>{date}</span>
                                    </div>
                                    <img src={image} alt=""/>
                                </div>
                            </div>
                        ))}
                    </div>

                </div>

                <div className={'dashboard_wrapper_events'}>
                    <div className={'dashboard_wrapper_business_top'}>
                        <h1 className={'heading'}>Upcoming Events & Programs</h1>
                    </div>
                    <div className={'dashboard_wrapper_events_bottom'}>
                        {events.map(({id, title, image, description, date}, index) => (
                            <EventCard
                                key={index + title}
                                id={id}
                                title={title}
                                image={image}
                                description={description}
                                date={date}
                            />
                        ))}
                    </div>
                </div>

                <div className={'dashboard_wrapper_business'}>
                    <div className={'dashboard_wrapper_business_top'}>
                        <h1 className={'heading'}>The ultimate guide to business success</h1>
                    </div>
                    <div className={'dashboard_wrapper_business_bottom'}>
                        {
                            businessOption.map(({image, heading, desc, link}, index) => (
                                <div className={'dashboard_wrapper_business_bottom_content'} key={index}
                                     onClick={() => navigate(link)}>
                                    <div className={'dashboard_wrapper_business_bottom_content_image'}>
                                        {image}
                                    </div>
                                    <div className={'dashboard_wrapper_business_bottom_content_text'}>
                                        <h4>{heading}</h4>
                                        <span>incomplete!</span>
                                    </div>
                                </div>
                            ))
                        }

                    </div>
                </div>

                <div className={'dashboard_wrapper_news'}>
                    <div className={'dashboard_wrapper_news_top'}>
                        <h1 className={'heading'}>Trending Topics</h1>
                        <div><span>View All</span></div>
                    </div>
                    <div className={'dashboard_wrapper_news_bottom'}>
                        {topNews.map(({id, date, heading, description, link, image}, index) => (
                            <div className={'dashboard_wrapper_news_bottom_content'} key={index}
                                 onClick={() => navigate(`/app/news/news/${id}`)}>
                                <div className={'dashboard_wrapper_news_bottom_content_left'}>
                                    <img src={image} alt=""/>
                                </div>
                                <div className={'dashboard_wrapper_news_bottom_content_right'}>
                                    <h1>{heading}</h1>
                                    <p>{description}</p>
                                    <div className={'date'}>
                                        <DATE_ICON/>
                                        <span>{date}</span>
                                    </div>
                                </div>
                            </div>

                        ))}
                    </div>
                </div>

            </div>

        </div>
    )
};

export default Dashboard;


